var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"modal",staticClass:"ui modal",class:{ fullscreen: _vm.fullscreen },style:(_vm.modalStyle)},[(!_vm.hideHeader)?_c('div',{staticClass:"header"},[_vm._t("header")],2):_vm._e(),_c('div',{staticClass:"scrolling content"},[_vm._t("content")],2),(!_vm.hideFooter)?_c('div',{staticClass:"actions"},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }